export default "__VITE_PUBLIC_ASSET__86d57228__"